import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs/Observable'
import { environment } from '../../../environments/environment'

export interface NbMusicrowItem {
  id: number
  title: string
  ordering: number
  aspect_ratio: string
  version: string
  image?: string
}

export interface NbMusicrow {
  id: number
  title: string
  type: string
  active?: boolean
  aspect_ratio: string
  version: string
  professional?: boolean
  only_personal?: boolean
  ordering: number
  items: NbMusicrowItem[]
  marketing?: NbMusicrowExtend
  usage?: NbMusicrowUsage
  gradient_start_color?: string
  gradient_end_color?: string
  list_definition?: string
}

export interface NbMusicrowExtend {
  id: number
  url: string
  after_appversion: string
  before_appversion: string
  android_after_appversion: string
  android_before_appversion: string
  monthly_hours_min: number
  monthly_hours_max: number
  membership_individual: number
  membership_coach: number
  membership_unlimited: number
  bol_membership_individual: boolean
  bol_membership_coach: boolean
  bol_membership_unlimited: boolean
  client: string
  devices: number
  device_ios: boolean
  device_android: boolean
  button_text: string
  button_text_color: string
  button_background_color: string
}

export interface NbMusicrowUsage {
  id: number
  url: string
  show_usage: boolean
  usage_color: string
  markup_text: string
  markup_title: string
  button_text: string
  button_text_color: string
  button_background_color: string
  background_color: string
}

export interface NbMusicrowResponse {
  success: boolean
  row: NbMusicrow
}

export interface NbMusicrowsResponse {
  success: boolean
  rows: NbMusicrow[]
}

export interface NbMusicrowItemResponse {
  success: boolean
  item: NbMusicrowItem
}
export interface NbMixListResponse {
  success: boolean
  mixes?: any[]
}
export interface NbDjListResponse {
  success: boolean
  djs?: any[]
}

export interface NbModalityListResponse {
  success: boolean
  modalities?: any[]
}

export interface NbRunningListResponse {
  success: boolean
  runnings: any[]
}

export interface NbMusicrowSuccessResponse {
  row?: number
  success: boolean
}

@Injectable()
export class MusicrowService {
  private API_ENDPOINT = `${environment.HOST}/adminapi/music/`

  constructor(private http: HttpClient) {}

  public getMusicRows(): Observable<NbMusicrowsResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}getrows`)
      .map(res => res as NbMusicrowsResponse)
  }

  public getMusicRowByID(id: number): Observable<NbMusicrowResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}getrow/id/${id}`)
      .map(res => res as NbMusicrowResponse)
  }

  public saveMusicrow(row: NbMusicrow): Observable<NbMusicrowSuccessResponse> {
    return this.http
      .post(`${this.API_ENDPOINT}saverow`, row)
      .map(res => res as NbMusicrowSuccessResponse)
  }

  public saveOrder(rows: NbMusicrow[]): Observable<any> {
    return this.http
      .post(`${this.API_ENDPOINT}saveroworder`, rows)
      .map(res => res as any)
  }

  public deleteMusicrow(id: number): Observable<NbMusicrowSuccessResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}deleterow/id/${id}`)
      .map(res => res as NbMusicrowSuccessResponse)
  }

  public getMixes(): Observable<NbMixListResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}getmixes`)
      .map(res => res as NbMixListResponse)
  }

  public getDjs(): Observable<NbDjListResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}getdjslist`)
      .map(res => res as NbDjListResponse)
  }

  public getModalities(): Observable<NbModalityListResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}getmodalitieslist`)
      .map(res => res as NbModalityListResponse)
  }
  public getRunning(): Observable<NbRunningListResponse> {
    return this.http
      .get(`${this.API_ENDPOINT}getrunnings`)
      .map(res => res as NbRunningListResponse)
  }
}



// WEBPACK FOOTER //
// /srv/staging/FitRadioAdmin2/src/app/@core/data/musicrow.service.ts